import { render, staticRenderFns } from "./GlossMediaDisplay.vue?vue&type=template&id=25bc7cc2&"
import script from "./GlossMediaDisplay.vue?vue&type=script&lang=ts&"
export * from "./GlossMediaDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports